module.exports = __webpack_public_path__ + "static/media/codOverview.08587bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/codOverview.png
// module id = 97
// module chunks = 0